// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useParams, Link } from "react-router-dom";
// import DOMPurify from "dompurify";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faClock } from "@fortawesome/free-solid-svg-icons";

// const baseUrl = "https://api.shabdtoday.com/";
// const apiUrl = "https://api.shabdtoday.com/api/home/stateNews";
// const clickOnline = "https://api.shabdtoday.com/api/home/update-viewcount";

// const StateNewsCard = () => {
//   const { slug } = useParams();
//   const [news, setNews] = useState([]);
//   const [stateInfo, setStateInfo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [fetching, setFetching] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const observer = useRef();

//   const fetchNews = async () => {
//     if (!hasMore || fetching || !slug) return;
//     setFetching(true);

//     try {
//       const response = await axios.get(`${apiUrl}?slug=${slug}&page=${page}&limit=5`);
//       const data = response.data;

//       if (data && data.tazaKhabars?.length > 0) {
//         setStateInfo({
//           hindi: data.stateTitleHindi,
//           english: data.stateTitleEnglish,
//         });

//         setNews((prevNews) => {
//           const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
//           const newItems = data.tazaKhabars.filter((item) => !existingIds.has(item.mainKhabarId));
//           return [...prevNews, ...newItems];
//         });

//         setPage((prev) => prev + 1);
//       } else {
//         setHasMore(false);
//       }
//     } catch (err) {
//       console.error("Error fetching state news:", err.message);
//     }

//     setFetching(false);
//     setLoading(false);
//   };

//   useEffect(() => {
//     setNews([]);
//     setPage(1);
//     setHasMore(true);
//     setLoading(true);
//     fetchNews();
//   }, [slug]);

//   useEffect(() => {
//     observer.current = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting) fetchNews();
//     });

//     const target = document.getElementById("load-more");
//     if (target) observer.current.observe(target);

//     return () => observer.current?.disconnect();
//   }, [news]);

//   const handleClick = async (slug, mainKhabarId) => {
//     try {
//       await axios.post(clickOnline, { mainKhabarId });
//       window.location.href = `/News-Details/${slug}`;
//     } catch (err) {
//       console.error("View count update failed:", err.message);
//       window.location.href = `/News-Details/${slug}`;
//     }
//   };

//   if (loading)
//     return (
//       <div className="loading-container">
//         <p>Loading state news...</p>
//       </div>
//     );

//   return (
//     <div className="container" style={{ maxWidth: "1200px", margin: "auto", padding: "10px" }}>
//       {stateInfo && (
//         <h1
//           style={{
//             fontSize: "28px",
//             fontWeight: "700",
//             margin: "20px 0",
//             borderBottom: "3px solid crimson",
//             display: "inline-block",
//           }}
//         >
//           {stateInfo.hindi} <span style={{ color: "#555" }}>({stateInfo.english})</span>
//         </h1>
//       )}

//       <div className="state-news-grid" style={{ display: "grid", gap: "20px" }}>
//         {news.map((post) => (
//           <article
//             key={post.mainKhabarId}
//             className="ak-module"
//             style={{
//               border: "1px solid #ddd",
//               borderRadius: "10px",
//               overflow: "hidden",
//               boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//               transition: "transform 0.2s ease",
//               background: "#fff",
//             }}
//           >
//             <Link
//               to="#"
//               onClick={(e) => {
//                 e.preventDefault();
//                 handleClick(post.slug, post.mainKhabarId);
//               }}
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               <div className="image-wrapper" style={{ position: "relative" }}>
//                 <img
//                   src={baseUrl + post.newsImage}
//                   alt={post.newsHeading}
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     display: "block",
//                     objectFit: "cover",
//                   }}
//                 />
//               </div>
//               <div style={{ padding: "15px" }}>
//                 <h2
//                   style={{
//                     fontSize: "20px",
//                     fontWeight: "600",
//                     marginBottom: "10px",
//                     color: "#111",
//                     lineHeight: "1.4",
//                   }}
//                   dangerouslySetInnerHTML={{
//                     __html: DOMPurify.sanitize(post.newsHeading),
//                   }}
//                 />
//                 <div style={{ display: "flex", alignItems: "center", color: "#777" }}>
//                   <FontAwesomeIcon icon={faClock} style={{ color: "crimson", marginRight: "5px" }} />
//                   <span style={{ fontSize: "13px" }}>{post.date?.split("T")[0]}</span>
//                 </div>
//               </div>
//             </Link>
//           </article>
//         ))}
//       </div>

//       <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
//         {fetching && <p>Loading more news...</p>}
//         {!hasMore && <p>No more news for this state.</p>}
//       </div>
//     </div>
//   );
// };

// export default StateNewsCard;
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

const baseUrl = "https://api.shabdtoday.com/";
const onlineStateNews = "https://api.shabdtoday.com/api/home/stateNews";
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount";

const isDesktopScreen = () => window.innerWidth >= 1024;

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) return text.substring(0, maxLength) + "...";
  return text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "...");
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) newNode.appendChild(traverse(child));
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const StateNewsCard = () => {
  const { slug } = useParams();
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const [stateTitle, setStateTitle] = useState("");
  const observer = useRef();

  const fetchStateNews = async () => {
    if (!slug || !hasMore || fetching) return;
    setFetching(true);

    try {
      const response = await axios.get(
        `${onlineStateNews}?slug=${slug}&page=${page}&limit=5`
      );

      if (response.data && response.data.tazaKhabars.length > 0) {
        if (response.data.stateTitleHindi) {
          setStateTitle(response.data.stateTitleHindi);
        }

        setNews((prev) => {
          const existingIds = new Set(prev.map((i) => i.mainKhabarId));
          const newItems = response.data.tazaKhabars.filter(
            (item) => !existingIds.has(item.mainKhabarId)
          );
          return [...prev, ...newItems];
        });

        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching state news:", err.message);
      setError("समाचार लोड करने में समस्या हुई");
    }

    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    setNews([]);
    setPage(1);
    setHasMore(true);
    setLoading(true);
    fetchStateNews();
  }, [slug]);

  useEffect(() => {
    const handleResize = () => setIsDesktop(isDesktopScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) fetchStateNews();
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      await axios.post(clickonline, { mainKhabarId });
      window.location.href = `/News-Details/${slug}`;
    } catch (error) {
      console.error("Failed to update view count:", error.message);
    }
  };

  if (error) return <div>{error}</div>;

  return (
    <div>
      {stateTitle && (
        <h2
          style={{
            color: "#c00",
            borderBottom: "2px solid #c00",
            paddingBottom: "5px",
            marginBottom: "20px",
          }}
        >
          {stateTitle}
        </h2>
      )}

      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;

                      return (
                        <article
                          key={post.mainKhabarId}
                          className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix"
                          style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}
                        >
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-featured-cover">
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                >
                                  <div className="ak-module-details mb-2">
                                    <h1 className="ak-module-title">
                                      <span
                                        className="responsive-font"
                                        style={{ lineHeight: "30px" }}
                                        dangerouslySetInnerHTML={{ __html: htmlContent }}
                                      />
                                    </h1>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                    <img
                                      src={baseUrl + post.newsImage}
                                      alt={stripHtmlTags(post.newsTag, 150)}
                                      width={410}
                                      height={300}
                                      style={{ objectFit: "fill" }}
                                    />
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );
};

export default StateNewsCard;
